var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip-group',{attrs:{"mandatory":"","center-active":"","active-class":"secondary font-weight-medium"},model:{value:(_vm.slider),callback:function ($$v) {_vm.slider=$$v},expression:"slider"}},_vm._l((_vm.categories),function(category){return _c('h-chip',_vm._b({key:category.id},'h-chip',category,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }